"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var statusQueueConstants = /** @class */ (function () {
    function statusQueueConstants() {
    }
    statusQueueConstants.naFila = "Na fila";
    statusQueueConstants.atendimentoIniciado = "Atendimento iniciado";
    statusQueueConstants.emAtendimento = "Em atendimento";
    statusQueueConstants.atendimentoEncerrado = "Atendimento encerrado";
    statusQueueConstants.atendimentoInativo = "Atendimento encerrado por inatividade";
    statusQueueConstants.atendimentoCancelado = "Atendimento cancelado";
    return statusQueueConstants;
}());
exports.default = statusQueueConstants;
//# sourceMappingURL=status-queue.js.map